import _styled, { default as _styled2 } from "styled-components";
/* eslint-disable jsx-a11y/label-has-associated-control */
var _templateObject;
var _excluded = ["description", "error", "feedback", "id", "name", "onBlur", "onChange", "required", "value"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import * as styles from "./styles";
import { TextField } from "../../elements/TextField/TextField";

// Omit "maxLength" & require keys: "id" | "name" | "onChange"

export var EntryField = function EntryField(_ref) {
  var description = _ref.description,
    error = _ref.error,
    feedback = _ref.feedback,
    id = _ref.id,
    name = _ref.name,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    required = _ref.required,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    textareaHasKeyboardFocus = _useState2[0],
    setTextareaHasKeyboardFocus = _useState2[1];
  var isValid = !textareaHasKeyboardFocus && value && !error;
  var handleTextAreaBlur = function handleTextAreaBlur(event) {
    setTextareaHasKeyboardFocus(false);
    onBlur === null || onBlur === void 0 || onBlur(event);
  };
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-has-error": !!error,
    "data-has-focus": textareaHasKeyboardFocus,
    "data-is-valid": isValid,
    $_css: styles.entryFieldContainer
  }, required && /*#__PURE__*/React.createElement(_StyledP, {
    "aria-hidden": "true",
    "data-has-error": !!error,
    "data-is-valid": isValid,
    $_css2: styles.requiredLabel
  }, "Required"), /*#__PURE__*/React.createElement(TextField, _extends({
    description: description,
    error: error,
    feedback: feedback,
    id: id,
    label: name,
    name: name,
    onBlur: handleTextAreaBlur,
    onChange: onChange,
    onFocus: function onFocus() {
      return setTextareaHasKeyboardFocus(true);
    },
    required: required,
    value: value
  }, props)));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledP = /*#__PURE__*/_styled2("p").withConfig({
  displayName: "EntryField___StyledP",
  componentId: "sc-sh86gp-0"
})(["", ""], function (p) {
  return p.$_css2;
});